import CustomButton from "common/components/Button/Button"
import Dropzone from "common/components/Dropzone"
import FormikDropdown from "common/components/FormikFields/FormikDropdown"
import FormikInputText from "common/components/FormikFields/FormikInputText"
import {
  canEditCategoriasSelector,
  categoriasOptionsWithParent,
  categoriasSelector,
} from "features/Inventario/redux/selectors/categoriasSelectors"
import { createCategoria } from "features/Inventario/redux/slices/categoriasSlice"
import { withFormik } from "formik"
import { useSelector } from "hooks/useSelector"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import * as Yup from "yup"
import ImagePreview from "../ImagePreview"

const CategoriaForm = ({
  values,
  setFieldValue,
  handleSubmit,
  categoriasOptions,
  resetForm,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const enabledForm = useSelector(canEditCategoriasSelector)
  const { creatingCategoria, categoriaCreated } =
    useSelector(categoriasSelector)

  useEffect(() => {
    if (categoriaCreated) {
      resetForm()
    }
  }, [categoriaCreated, resetForm])

  const setImage = (image: $TSMigrationFixMe) => {
    setFieldValue("imageFile", image)
  }

  const deleteImage = () => {
    setImage(null)
  }

  const onDrop = (files: $TSMigrationFixMe) => {
    setImage(files?.[0])
  }

  return (
    <form
      className='mt-3 text-left p-fluid'
      onSubmit={handleSubmit}
    >
      <div className='p-field'>
        <label htmlFor='nombreCategoriaFormNew'>
          {t("categorias.form.labelName")}
        </label>
        <FormikInputText
          id='nombreCategoriaFormNew'
          name='nombreCategoria'
        />
      </div>

      <div className='p-fluid'>
        <label>{t("categorias.form.labelImg")}</label>

        <ImagePreview
          image={values.imageFile}
          setImage={setImage}
          deleteImage={deleteImage}
        />

        {!values.imageFile && (
          <Dropzone
            maxFiles={1}
            accept='image/*'
            onDrop={onDrop}
            hideAcceptedFilesMsg
            butonLabel={`${t("categorias.form.dropzoneButton")}`}
          />
        )}
      </div>

      <div className='mt-3 p-formgrid p-grid p-fluid align-items-end'>
        <div className='p-field p-col-8'>
          <label htmlFor='categoriaPadreFormNew'>
            {t("categorias.form.labelFatherCategory")}
          </label>

          <FormikDropdown
            filter
            showClear
            disabled={!enabledForm}
            options={categoriasOptions}
            placeholder={`${t("categorias.form.placeholderFatherCategory")}`}
            id='categoriaPadreFormNew'
            name='categoriaPadre'
          />
        </div>

        <div className='p-field p-col-4'>
          <CustomButton
            className='!tw-bg-primary tw-cursor-pointer'
            loading={creatingCategoria}
            label={`${t("categorias.form.labelAdd")}`}
            type='submit'
          />
        </div>
      </div>
    </form>
  )
}

const mapFormValuesToPostCategoria = (values: $TSMigrationFixMe) => ({
  categoriaPadreId: values.categoriaPadre || null,
  imageFile: values.imageFile,
  nombre: values.nombreCategoria,
})

const validationSchema = (t: $TSMigrationFixMe) =>
  Yup.object().shape({
    nombreCategoria: Yup.string().nullable().required(t("errors.nameEmpty")),
  })

const NewCategoriaForm = withFormik({
  mapPropsToValues: () => ({
    nombreCategoria: "",
    imageFile: "",
    categoriaPadre: "",
  }),
  validationSchema: ({ t }: $TSMigrationFixMe) => validationSchema(t),
  handleSubmit: async (values, { props }) => {
    const postCategoria = mapFormValuesToPostCategoria(values)
    // @ts-expect-error TS(2339): Property 'createCategoria' does not exist on type ...
    props.createCategoria(postCategoria)
  },
})(CategoriaForm)

const mapStateToProps = (state: $TSMigrationFixMe) => ({
  categoriasOptions: categoriasOptionsWithParent(state),
})

const mapDispatchToProps = (dispatch: $TSMigrationFixMe) => ({
  createCategoria: (categoria: $TSMigrationFixMe) =>
    dispatch(createCategoria(categoria)),
})

export default connect(mapStateToProps, mapDispatchToProps)(NewCategoriaForm)
